import React, { useState, useEffect } from 'react';
import './WelcomeCard.css';
import IconSvg from '../../../assets/icons/Icon.svg';

const WelcomeCard = ({ isDarkMode, onQuickStartClick, disableQuickStart = false }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [stepsVisible, setStepsVisible] = useState([false, false, false]);

  useEffect(() => {
    // Trigger entrance animation
    setIsVisible(true);

    // Stagger the reveal of steps
    const timers = [
      setTimeout(() => setStepsVisible([true, false, false]), 100),
      setTimeout(() => setStepsVisible([true, true, false]), 250),
      setTimeout(() => setStepsVisible([true, true, true]), 400)
    ];

    return () => {
      timers.forEach(timer => clearTimeout(timer));
    };
  }, []);

  const steps = [
    {
      number: '1',
      title: 'Choose Symbol',
      description: 'Select the instrument you want to trade'
    },
    {
      number: '2',
      title: 'Review Validation Pipeline',
      description: 'Review rules and gates'
    },
    {
      number: '3',
      title: 'Create & Validate',
      description: 'Set up trade and validate'
    }
  ];

  return (
    <div className={`welcome-card-container ${isDarkMode ? 'dark-mode' : ''} ${isVisible ? 'visible' : ''}`}>
      <div className="welcome-card">
        {/* Icon/Illustration */}
        <div className="welcome-icon">
          <img
            src={IconSvg}
            alt="NanoTrader Copilot Logo"
            className="icon-svg"
          />
        </div>

        {/* Welcome Title */}
        <h2 className="welcome-title">Welcome to NanoTrader Copilot</h2>
        <p className="welcome-subtitle">Get started in 3 simple steps</p>

        {/* Steps */}
        <div className="welcome-steps">
          {steps.map((step, index) => (
            <div
              key={index}
              className={`welcome-step ${stepsVisible[index] ? 'visible' : ''}`}
              style={{ transitionDelay: `${index * 150}ms` }}
            >
              <div className="step-number">{step.number}</div>
              <div className="step-content">
                <h3 className="step-title">{step.title}</h3>
                <p className="step-description">{step.description}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Quick Start Guide Button */}
        <button
          className="quick-start-button"
          onClick={onQuickStartClick}
          aria-label="Open Quick Start Guide"
          disabled={disableQuickStart}
        >
          Quick Start Guide
        </button>
      </div>
    </div>
  );
};

export default WelcomeCard;
